export interface IPAYBACK_FORMULA {
  investment: number;
  cashInflow: number;
}

export const PAYBACK_FORMULA = ({
  investment,
  cashInflow,
}: IPAYBACK_FORMULA) => {
  if (
    investment < 1 ||
    investment > 1e10 ||
    cashInflow < 1 ||
    cashInflow > 1e10
  ) {
    const emptyRes = 0;
    return {
      paybackPeriod: emptyRes.toFixed(2),
    };
  }
  const invest = investment;
  const cashIn = cashInflow;

  const payback = invest / cashIn;
  return {
    paybackPeriod: payback.toFixed(2),
  };
};
